import { isInTriageMode } from 'pages/alerts/utils';

import { AnalyticsAction } from '../../../constants';
import { createContexts } from '../../utils';
import { getIntelView } from '../utils';

import type { EventDefinition } from '../../types';

export const impression: EventDefinition = {
  getData: (action, eventData = {}) => {
    const triageMode = isInTriageMode();
    const intelRank = triageMode ? 1 : eventData?.rank;
    const view = getIntelView(eventData);
    const rank =
      action === AnalyticsAction.boardCard ? eventData?.rank : intelRank;
    return action && eventData ? { type: action, view, rank } : {};
  },
  addContexts: ({ action, eventData, filterData } = {}) => {
    const entityType = action === AnalyticsAction.boardCard ? 'board' : 'intel';
    const commonContexts = createContexts([entityType], { eventData });
    const view = getIntelView(eventData);
    const includeIntelFilter = view === 'list' || view === 'triage';
    if (includeIntelFilter) {
      const intelFilterContext = createContexts(['intelfilter'], {
        eventData,
        filterData,
        transformers: {
          intelfilter: (eventData, filterData) => ({
            ...filterData,
            ...eventData.intelfilter,
          }),
        },
      });
      return [...commonContexts, ...intelFilterContext];
    }

    return commonContexts;
  },
};
